var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagDe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 400,
    viewBox: "0 0 8 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 5,
    fill: "#000000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1.6667,
    width: 8,
    height: 1.6667,
    fill: "#dd0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 3.3333,
    width: 8,
    height: 1.6667,
    fill: "#ffce00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDe);
export default __webpack_public_path__ + "static/media/flag-de.b7dc6ccac47bb09a9f64467c1936c194.svg";
export { ForwardRef as ReactComponent };